import { Badge } from 'react-bootstrap'
import EqxIcon from '../EqxIcon'

interface EqxBadgeProps {
    variant?: string
    icon?: string
    text?: string
    threshold?: string
    className?: string
    title?: string
    onClick?: () => void
}
export default (props: EqxBadgeProps) => {
    return (
        <Badge bg={props.variant} className={props.className} title={props.title} onClick={props.onClick} style={props.onClick ? { cursor: 'pointer' } : {}}>
            {props.icon && <EqxIcon fa={props.icon} className="me-1" />}
            {props.text && (
                <span className={props.threshold && props.icon ? 'd-none d-' + props.threshold + '-inline ms-1' : ''}>
                    {props.text}
                </span>
            )}
        </Badge>
    )
}
